import Select, { SelectProps } from './Select';
import { is } from 'ramda';
import axios from 'axios';
import UserGroupDataModel from '../DataModel/UsersDataService';
import { equals } from "ramda";

const { SupervisedUserCircle, AccountCircle, AccountCircleOutlined } = (window as any).MaterialIcons;
const { Chip, withStyles, TextField, Tooltip, Icon } = window.Material;

interface AuthorityProps extends SelectProps {
	allowSystem: boolean;
	disableExternalGroups: boolean;
	disableExternalUsers: boolean;
	disableNodeRef: Array<string>;
	autoFocus: boolean;
	parentAuthority: string;
	valueParam: string;
	type: string;
	classes: any;
	disabled: boolean;
	root: string | null;
	value: any;
	renderOption: any;
	excludedOptions?:any;
}
type Option = { [key: string]: any };
interface AuthorityState {
	inputValue: string;
	loading: boolean;
	matchDisabled: boolean;
	matchSystem: boolean;
	options: Option | Option[] | any;
  }

let DataService: UserGroupDataModel;

const makeRequestCreator = () => {
	let call: any;
	return (url: string, init: boolean | undefined) => {
		if (call && !init) {
			call.cancel();
		}
		call = axios.CancelToken.source();
		return axios.get(url, {
			cancelToken: call.token,
		});
	};
};
const requestCreator = makeRequestCreator();

const styles = {
	userChip: {
		background: 'rgb(162, 218, 255)',
	},
	groupChip: {
		background: 'rgb(255, 208, 123)',
	},
	enabledUser: {
		display: 'flex',
		position: 'absolute',
		right: '14px',
		alignItems: 'center',
		'& .MuiAutocomplete-endAdornment': {
			position: 'relative',
			right: 0,
		},
	},
	icon: {
		'&:hover': {
			cursor: 'pointer',
		},
	},
	optionIcon: {
		fontSize: '.9rem',
		width: '20px',
		textAlign: 'center',
		display: 'inline-block',
		marginRight: '.35rem',
		color: 'rgb(255, 208, 123)',
		'&.fa-user': {
			color: 'rgb(162, 218, 255)',
		},
	},
};

class Authority extends React.PureComponent<AuthorityProps, AuthorityState> {
	constructor(props: AuthorityProps) {
		super(props);

		DataService = new UserGroupDataModel();

		const initialState = {
			options: [],
			loading: true,
			matchDisabled: false,
			matchSystem: false,
			inputValue: '',
		};

		this.state = initialState;
	}

	static defaultProps = {
		valueParam: 'nodeRef',
	};

	componentDidMount() {
		this.getOptions();
	}

	componentDidUpdate(prevProps: AuthorityProps, prevState: AuthorityState) {
		if (this.props.type !== prevProps.type) {
			this.getOptions();
		} else if (!equals(prevProps.value, this.props.value)) {
			this.getOptions();
		  } 

		const inputVal = this.props?.multi
			? ''
			: typeof this.state?.inputValue === 'string' && this.state.inputValue.length > 0
			? (prevProps.value !== null && this.props.value === null ? '' : this.state.inputValue)
			: this.props.value?.label ?? '';

		if (!this.props?.multi && prevState?.inputValue !== inputVal) {
			this.setState(state => {
				return { ...state, inputValue: inputVal };
			});
		}
	}

	onInputChange = (event: any) => {
		const { value } = event.target as HTMLInputElement;
		if (event.nativeEvent?.type === 'input') {
			this.setState(state => {
				return { ...state, inputValue: value ?? '' };
			});
			this.getOptions(value);
		}
	};

	handleChange = (val: any) => {
		let { onChange, multi } = this.props;
		if (typeof onChange === 'function') {
			onChange(val);
		}
		//reset Input value on change
		this.setState((state) => {
			return { ...state, loading: false, inputValue: multi ? '' : val?.label };
		});
		this.getOptions();
	};

	getOptions = async (input = '') => {
		let { type, parentAuthority, valueParam, allowSystem, root, value } = this.props;

		if (type === 'cm:person' || type === 'USER') type = 'USER';
		else if (type === 'cm:authorityContainer' || type === 'GROUP') type = 'GROUP';
		else type = '';

		const params = {
			type: type ? type : '',
			filter: input ? input : '',
			parentAuthority: parentAuthority ? parentAuthority : '',
			matchDisabled: this.state.matchDisabled ? this.state.matchDisabled : false,
			matchSystem: allowSystem ? true : false,
			root: root ? root : '',
		};
		let options:Option [] | Option | any = await DataService.getUserOptions(value, params);
		let selectedOptions:Option[] = options ? this.mapOptions(options[0], valueParam) : [];
		if(type === ''){
			options = options ? this.mapOptions(options[1].sort(DataService.sortByTypeByName), valueParam) : [];
		} else {
			options = options[1] ? this.mapOptions(options[1], valueParam) : [];
		}
		options = options.concat(selectedOptions);
		this.setState(
			(state) => ({
				...state,
				options: options,
				loading: false,
			}
			)
		);
	};

	getOptionDisabled = (option:any) => {
		const{excludedOptions} = this.props;
		return (
			this.props.disableExternalGroups  && option.type === 'GROUP' &&  (option?.external??false) ||
			this.props.disableExternalUsers  && option.type === 'USER' &&  (option?.external??false) ||
			this.props?.disableNodeRef?.[0] === option?.uuid ||
			excludedOptions?.includes(option?.value)
			);
		};

	mapOptions = (options: any, valueParam: any) => {
		return options.map((it: any) => ({
			...it,
			label: it?.displayName ?? it.id,
			value: valueParam === 'nodeRef' ? `workspace://SpacesStore/${it.uuid}` : it.id,
			type: it?.type,
		}));
	};

	getDisabled = (event: React.MouseEvent) => {
		event?.preventDefault();
		this.getOptions(this.state.inputValue);
		this.setState({ matchDisabled: !this.state.matchDisabled });
	};

	renderTags = (value: any) =>{
	return value.map((item: any) => {
			const { onChange, classes, disabled } = this.props;
			let icon: any;
			let style: any;

			if (item === null) {
				console.error('The tag/autority is null');
			}

			switch (item?.type ?? '') {
				case 'USER':
				case 'cm:person': {
					icon = <AccountCircle />;
					style = item.enabled ? classes.userChip : classes.enabledChip;
					break;
				}
				case 'GROUP':
				case 'cm:authorityContainer': {
					icon = <SupervisedUserCircle />;
					style = classes.groupChip;
					break;
				}
				default: {
					icon = null;
					style = null;
					break;
				}
			}
			return (
				<Chip
					className="MuiAutocomplete-tag"
					classes={{ root: style }}
					key={item?.value}
					avatar={icon}
					label={item?.label}
					size="small"
					onDelete={
						onChange && !disabled ? () => onChange(value?.filter((it: any) => it?.value !== item?.value)) : null
					}
				/>
			);
		});
	}

	render() {
		const { classes, type } = this.props;
		let value: any;
		if (is(String, this.props?.value)) value = this.state.options.find(item => item.value === this.props.value);
		else if (this.props?.value?.length > 0 && this.props?.value.every((it: any) => typeof it === 'string'))
			value = this.state.options.filter((item: any) => this.props.value.includes(item.value));
		else value = this.props.value;
		return (
			//@ts-ignore
			<Select
				{...{ ...this.props }}
				onChange={this.handleChange}
				options={this.state.options}
				getOptionDisabled={this.getOptionDisabled}
				value={value || []}
				getOptionSelected={(option, value) => {
					return value.value === option.value;
				  }}
				getOptionLabel={
					(option) => (`${option?.displayName}`)
				}
				groupBy={
					!this.state.matchDisabled || (type !== 'USER' && type !== 'cm:person' && type !== 'cm:authority')
						? null
						: (option: any) => {
								return option?.enabled !== undefined
									? option.enabled
										? window.Alfresco.messages.global['edocat.all-workflows.filter.active']
										: window.Alfresco.messages.global['edocat.about-page.description.inactive']
									: 'Skupiny';
						  }
				}
				renderInput={(params: any) => (
					<TextField
						{...params}
						onChange={this.onInputChange}
						label={this.props?.label ?? ''}
						variant={'outlined'}
						required={this.props?.mandatory}
						error={!!this.props?.error}
						helperText={this.props?.error || this.props?.important || this.props?.helperText}
						InputLabelProps={{ shrink: true }}
						inputProps={{
							...params.inputProps,
							value: !this.props?.multi
								? typeof this.state?.inputValue === 'string' && this.state.inputValue.length > 0
									? this.state.inputValue
									: this.props.value?.label ?? ''
								: this.state?.inputValue ?? '',
						}}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<div className={classes.enabledUser}>
									{params.InputProps.endAdornment}
									{(type === 'USER' || type === 'cm:person' || type === 'cm:authority') && (
										<React.Fragment>
											{!this.state.matchDisabled && (
												<Tooltip title={window.Alfresco.messages.global['edocat.authority-inactive']} placement="top">
													<AccountCircle
														color={this.props.disabled ? 'disabled' : 'primary'}
														className={classes.icon}
														onClick={this.props.disabled ? null : this.getDisabled}
													/>
												</Tooltip>
											)}
											{this.state.matchDisabled && (
												<Tooltip title={window.Alfresco.messages.global['edocat.authority-active']}>
													<AccountCircleOutlined
														color={this.props.disabled ? 'disabled' : 'primary'}
														className={classes.icon}
														onClick={this.props.disabled ? null : this.getDisabled}
													/>
												</Tooltip>
											)}
										</React.Fragment>
									)}
								</div>
							),
						}}
					/>
				)}
				renderTags={this.props.multi ? this.renderTags : null}
				renderOption={(option: any) => (
					<React.Fragment>
						<Icon
							className={`${classes.optionIcon} fas fa-${option.type === 'GROUP' ? 'users' : 'user'}`}
							fontSize="small"
						/>
						{option.label}
					</React.Fragment>
				)}
			/>
		);
	}
}

export default withStyles(styles)(Authority);
